import React, { useState } from "react";
import First from "../../images/logos/first.png";
import Second from "../../images/logos/second.png";
import Third from "../../images/logos/New/operation.png";
import Forth from "../../images/logos/fourth.png";
import Fifth from "../../images/logos/New/fifth.png";
import Sixth from "../../images/logos/New/Sixth.png";
import Seven from "../../images/logos/New/Seven.png";
import Eight from "../../images/logos/New/Eight.jpg";
import Nine from "../../images/logos/New/Nine.png";
import Ten from "../../images/logos/New/Ten.png";

const customers = [
  { id: 1, name: "SAUDI ARAMCO", number: "10012561", logo: First },
  { id: 2, name: "MARAFIQ", number: "2922", logo: Second },
  { id: 3, name: "AL KHAFJI JOINT OPERATIONS", number: "100110", logo: Third },
  { id: 4, name: "PETRO RABIG", number: "100779", logo: Forth },
  { id: 5, name: "SAUDI BASIC INDUSTRIES", number: "0000501935", logo: Fifth },
  { id: 6, name: "SAUDI ELECTRICITY COMPANY", number: "A0324", logo: Sixth },
  { id: 7, name: "SAUDI CHEVRON", number: "128822", logo: Seven },
  { id: 8, name: "SIPCHEM", number: "100284", logo: Eight },
  { id: 9, name: "MA’ADEN", number: "9894", logo: Nine },
  { id: 10, name: "SADARA", number: "1000002931", logo: Ten },
];

const ValuedCustomers = () => {
  const [isPaused, setIsPaused] = useState(false);

  const repeated = [...customers, ...customers];

  const handleClick = () => {
    setIsPaused(true);
  };

  const handleDoubleClick = () => {
    setIsPaused(false);
  };

  return (
    <div className="bg-white rounded-lg py-7 w-full overflow-hidden">
      <h2 className="text-xl md:text-4xl font-bold text-gray-800 text-center">
        OUR VALUED CUSTOMERS
      </h2>

      <div className="overflow-hidden w-full relative">
        <div className={`marquee-wrapper`}>
        <div className={`marquee-track flex ${isPaused ? "paused" : ""}`}>
            {repeated.map((customer, index) => (
              <div
                key={index}
                className="flex-none text-center cursor-pointer"
                style={{ minWidth: "250px" }}
                onClick={handleClick}
                onDoubleClick={handleDoubleClick}
              >
                <div className="w-[130px] h-[130px] mx-auto flex items-center justify-center">
                  <img
                    src={customer.logo}
                    alt={customer.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="font-semibold text-gray-600" style={{ marginTop: "-25px" }}>
                  {customer.name}
                </p>
                <p className="font-bold text-gray-900">{customer.number}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CSS for smoothly scroll and pause */}
      <style>{`
        .marquee-wrapper {
          width: 100%;
          overflow: hidden;
        }

        .marquee-track {
          display: flex;
          width: max-content;
          animation: scroll-left 20s linear infinite;
        }

        .paused {
          animation-play-state: paused !important;
        }

        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

export default ValuedCustomers;
